import React, { useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BiDownload, BiTrafficCone } from "react-icons/bi";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { MdSimCardAlert } from "react-icons/md";
import SalesOverview from "../../AdminComponents/SalesOverview";
import AreaChartMonthly from "../../AdminComponents/AreaChartMonthly";
import Transactions from "../../AdminScreen/Transactions";
import PieCharts from "../../AdminComponents/PieChart";
import SideBar from "../global/SideBar";
const OverViwData = [
  {
    id: "3ie",
    heading: "Total Customers",
    icon: <AiOutlineMail className=" text-YellowLight" />,
    number: 5251,
    link: "/customers",
    parcentage: 14,
  },
  {
    id: "3we",
    heading: "Sales Today",
    icon: <MdSimCardAlert className=" text-YellowLight" />,
    number: 7916,
    link: "/salesgraph",
    parcentage: 21,
  },
  {
    id: "3oe",
    heading: "Monthly Sales",
    icon: <BsFillPersonPlusFill className=" text-YellowLight" />,
    number: 59525,
    link: "/salesgraph",
    parcentage: 5,
  },
  {
    id: "3ke",
    heading: "Yearly Sales",
    icon: <BiTrafficCone className=" text-YellowLight" />,
    number: 65152,
    link: "/salesgraph",
    parcentage: 43,
  },
];

const DashBoard = () => {
  return (
    <div className="flex flex-col lg:flex-row">
      <SideBar />
      <div className="flex-1">
        <div className="  flex flex-col md:flex-row  justify-between  mt-5 mx-5 ">
          <div className="mb-2">
            <h1 className="text-xl font-bold text-Light">DASHBOARD</h1>
            <p className="text-sm">Welcome to your dashboard</p>
          </div>
          <div>
            <button className="flex justify-center items-center text-sm font-bold bg-YellowDark lg:px-4 text-BlueDark py-2 rounded">
              <BiDownload className=" inline-block mr-2 text-xl font-bold" />
              DOWNLOAD REPORT
            </button>
          </div>
        </div>

        {/* First row in Template */}
        <div className=" h-[115vh] lg:h-[33vh]  grid grid-cols-1 grid-rows-6  lg:grid-cols-12 grid-row-6 gap-2 mx-2 mt-0 mb-2 ">
          <div className=" row-span-4 lg:row-span-full lg:col-span-5 grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-x-2 md:gap-y-4 place-items-center lg:place-items-start ">
            {OverViwData.map((data) => {
              return (
                <SalesOverview
                  key={data.id}
                  heading={data.heading}
                  icon={data.icon}
                  number={data.number}
                  parcentage={data.parcentage}
                  link={data.link}
                />
              );
            })}
          </div>
          <div className=" bg-white rounded row-span-2 mt-2 lg:mt-0 lg:row-span-6 lg:col-span-7 shadow-xl">
            <AreaChartMonthly />
          </div>
        </div>

        {/* 2nd Row in  Template */}

        <div className=" h-[115vh] lg:h-[45vh]  grid grid-cols-1 grid-rows-6  lg:grid-cols-12 grid-row-6 gap-2 mx-2 mt-2 mb-10 lg:mb-2 ">
          <div className=" col-span-full row-span-3 lg:col-span-8 lg:row-span-full bg-white rounded overflow-hidden shadow-xl">
            <Transactions />
          </div>
          <div className=" col-span-full row-span-3 lg:col-span-4 lg:row-span-full bg-white rounded shadow-xl">
            <PieCharts />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoard;

//  <div>
//    <main className="flex flex-col h-[93vh]s w-[100%]">
//      {/* Grid Layout */}
//      {/* Row-1 */}
//  <div className="text-Light mx-4 grid grid-cols-1   md:grid-cols-12 gap-1  grid-rows-5">
//    <div className="md:col-span-full row-span-1 pt-3 flex justify-between   ">
//      <div>
//        <h1 className="text-xl font-bold">DASHBOARD</h1>
//        <p className="text-sm">Welcome to your dashboard</p>
//      </div>
//      <div>
//        <button className="flex justify-center items-center text-sm font-bold bg-YellowDark px-4 text-BlueDark py-2 rounded">
//          <BiDownload className=" inline-block mx-2 text-xl font-bold" />
//          DOWNLOAD REPORT
//        </button>
//      </div>
//    </div>
//        <div className="  md:col-span-5 row-span-4 grid grid-cols-1 md:grid-cols-2 grid-rows-2 gap-2 ">
//  {OverViwData.map((data) => {
//    return (
//      <SalesOverview
//        heading={data.heading}
//        icon={data.icon}
//        number={data.number}
//        parcentage={data.parcentage}
//      />
//    );
//  })}
//        </div>

//        <div className="bg-white col-span-7 row-span-4  ">
//  <AreaChartMonthly />
//        </div>
//      </div>
//      <div className="mx-4 h-full mt-2 grid grid-cols-12 grid-rows-6 gap-2 ">
//        <div className="bg-white col-span-8  row-span-6">Users</div>
//        <div className=" bg-white col-span-4 row-span-6">
//          Salse by category
//        </div>
//      </div>
//    </main>
//  </div>;
